export enum DocumentCapture {
  Alloy = 'alloy',
  Socure = "socure"
}
